import * as TabsPrimitive from "@radix-ui/react-tabs";
import classes from "./Tabs.module.scss";
import { clsx } from "clsx";
import { TabsTriggerProps } from "./TabsTriggerProps";
import { CheckCircle } from "@/components/ui/Icon/CheckCircle";

export function TabsTrigger(props: TabsTriggerProps) {
  const { children, className, ...rest } = props;

  return (
    <TabsPrimitive.Trigger
      className={clsx(classes.trigger, className)}
      {...rest}
    >
      {children}

      <CheckCircle size={24} className={classes.checkIcon} />
    </TabsPrimitive.Trigger>
  );
}
